import axios from './../api.js'

const state = {
    reportItemWhole: {
        taskDocumentList: []
    },
    requisitionVersionStamp: '',
    objectActivityVersionStamp: '',
    requisitionDocuments: [],
    requisitionEnquiryDocuments: [],
    requisitionTaskDocuments: [],
    reportFullObjectList: []
}

const getters = {
    reportItemWhole: state => {
        return state.reportItemWhole
    },
    getRequisitionVersionStamp: state => {
        return state.requisitionVersionStamp
    },
    getObjectActivityVersionStamp: state => {
        return state.objectActivityVersionStamp
    },
    getRequisitionDocuments: state => {
        return state.requisitionDocuments.sort((a, b) => new Date(b.dateCreated) - new Date(a.dateCreated))
    },
    getRequisitionEnquiryDocuments: state => {
        return state.requisitionEnquiryDocuments
    },
    getRequisitionTaskDocuments: state => {
        return state.requisitionTaskDocuments
    },
    getReportFullObjectList: state => {
        return state.reportFullObjectList
    }
}

const mutations = {
    addWholeReportItem: (state, payload) => {
        state.reportItemWhole = payload
        state.requisitionEnquiryDocuments = []
        state.requisitionTaskDocuments = []
        if (payload.sharedRequestDocumentList && payload.sharedRequestDocumentList.length > 0) {
            payload.sharedRequestDocumentList.forEach((file) => {
                if (file.contentType.startsWith('image/')) {
                    axios.downloadDocument('/Report/GetSharedRequestThumbnail', {
                        RequestId: file.requestId,
                        RequestDocumentId: file.requestDocumentId,
                        ThumbnailWidth: 180,
                        ThumbnailHeight: 180,
                        Crop: true
                    })
                        .then((response) => {
                            let blob = new Blob([response.data], { type: file.contentType })

                            state.requisitionEnquiryDocuments.push({
                                id: file.requestDocumentId,
                                dateCreated: file.created,
                                name: file.originalFileName,
                                contentType: file.contentType,
                                icon: null,
                                dataSource: window.URL.createObjectURL(blob),
                                photoTaken: file.photoTaken,
                                description: file.description,
                                origin: {
                                    name: 'enquiry',
                                    id: file.requestId
                                },

                                raw: file
                            })
                        })
                } else {
                    state.requisitionEnquiryDocuments.push({
                        id: file.requestDocumentId,
                        dateCreated: file.created,
                        name: file.originalFileName,
                        contentType: file.contentType,
                        icon: null,
                        dataSource: null,
                        photoTaken: file.photoTaken,
                        description: file.description,
                        origin: {
                            name: 'enquiry',
                            id: file.requestId
                        },

                        raw: file
                    })
                }
            })
        }
        if (payload.taskDocumentList && payload.taskDocumentList.length > 0) {
            payload.taskDocumentList.forEach((file) => {
                if (file.contentType.startsWith('image/')) {
                    axios.downloadDocument('/Report/GetTaskThumbnail', {
                        TaskId: file.taskId || payload.task.taskId,
                        TaskDocumentId: file.taskDocumentId,
                        ThumbnailWidth: 180,
                        ThumbnailHeight: 180,
                        Crop: true
                    })
                        .then((response) => {
                            let blob = new Blob([response.data], { type: file.contentType })

                            state.requisitionTaskDocuments.push({
                                id: file.taskDocumentId,
                                dateCreated: file.created,
                                name: file.originalFileName,
                                contentType: file.contentType,
                                icon: null,
                                dataSource: window.URL.createObjectURL(blob),
                                photoTaken: file.photoTaken,
                                description: file.description,
                                origin: {
                                    name: 'task',
                                    id: file.taskId || payload.task.taskId
                                },

                                raw: file
                            })
                        })
                } else {
                    state.requisitionTaskDocuments.push({
                        id: file.taskDocumentId,
                        dateCreated: file.created,
                        name: file.originalFileName,
                        contentType: file.contentType,
                        icon: null,
                        dataSource: null,
                        photoTaken: file.photoTaken,
                        description: file.description,
                        origin: {
                            name: 'task',
                            id: file.taskId || payload.task.taskId
                        },

                        raw: file
                    })
                }
            })
        }
    },
    setReportClear: (state, payload) => {
        state.reportItemWhole = {}
    },
    addRequisitionVersionStamp: (state, payload) => {
        state.requisitionVersionStamp = payload
    },
    addObjectActivityVersionStamp: (state, payload) => {
        state.objectActivityVersionStamp = payload
    },
    requisitionDocumentAdd: (state, obj) => {
        state.requisitionDocuments.push(obj)
    },
    updateRequisitionDocuments: (state, obj) => {
        if (obj.data.length === 1 && obj.data[0].updating) {
            state.requisitionDocuments.map(stateDoc => obj.data.find(newDoc => newDoc.id === stateDoc.id) || stateDoc)
        } else {
            state.requisitionDocuments = []
            obj.data.forEach((file) => {
                if (file.contentType.startsWith('image/')) {
                    axios.downloadDocument('/Report/GetReportThumbnail', {
                        RequisitionId: state.reportItemWhole.requisition.requisitionId,
                        ReportDocumentId: file.reportDocumentId,
                        ThumbnailWidth: 180,
                        ThumbnailHeight: 180,
                        Crop: true
                    })
                        .then((response) => {
                            let blob = new Blob([response.data], { type: file.contentType })

                            state.requisitionDocuments.push({
                                id: file.reportDocumentId, // Is `file.id` sometimes used?
                                dateCreated: file.created,
                                name: file.originalFileName, // Is `file.name` sometimes used?
                                contentType: file.contentType,
                                icon: null,
                                dataSource: window.URL.createObjectURL(blob),
                                photoTaken: file.photoTaken,
                                description: file.description,
                                origin: {
                                    name: 'requisition',
                                    id: state.reportItemWhole.requisition.requisitionId
                                },

                                raw: file
                            })
                        })
                } else {
                    state.requisitionDocuments.push({
                        id: file.reportDocumentId, // Is `file.id` sometimes used?
                        dateCreated: file.created,
                        name: file.originalFileName, // Is `file.name` sometimes used?
                        contentType: file.contentType,
                        icon: null,
                        dataSource: null,
                        photoTaken: file.photoTaken,
                        description: file.description,
                        origin: {
                            name: 'requisition',
                            id: state.reportItemWhole.requisition.requisitionId
                        },

                        raw: file
                    })
                }
            })
        }
    },
    detachRequisitionDocument: (state, obj) => {
        state.requisitionDocuments.splice(obj, 1)
    },
    updateReportObjectList: (state, payload) => {
        state.reportFullObjectList = state.reportItemWhole.objectList
        state.reportItemWhole.objectList = payload
    },
    clearReportObjectActivitiesFilter: (state) => {
        state.reportFullObjectList.forEach((o) => {
            if (!state.reportItemWhole.objectList.some(org => org.objectId === o.objectId)) {
                state.reportItemWhole.objectList.push(o)
            }
        })

        if (state.reportItemWhole.objectList) {
            if (state.reportItemWhole.objectList.length > 1) {
                state.reportItemWhole.objectList = state.reportItemWhole.objectList.sort((a, b) => {
                    const akeyValue = a.keyValue
                    const bkeyValue = b.keyValue
                    if (akeyValue < bkeyValue) {
                        return -1
                    } else if (akeyValue > bkeyValue) {
                        return 1
                    }
                    return 0
                })
            }
        }
    },
    setReportFullObjectList: (state, payload) => {
        state.reportFullObjectList = payload
    }
}

const actions = {
    requisitionDocumentAdd: ({commit, dispatch}, data) => {
        if (state.reportItemWhole.requisition.requisitionId === '') {
            return commit('requisitionDocumentAdd', {
                id: null,
                dateCreated: new Date().toISOString(),
                name: data.file.name,
                contentType: data.file.type,
                icon: null,
                dataSource: data.file.type.startsWith('image/') ? window.URL.createObjectURL(data.file) : null,
                photoTaken: data.dataType.includes('image/') ? data.file.lastModifiedDate || new Date(data.file.lastModified) : null,
                description: null,
                origin: {
                    name: 'requisition',
                    id: state.reportItemWhole.requisition.requisitionId
                },

                raw: data
            })
        }

        let dateString = data.file.lastModifiedDate || new Date(data.file.lastModified)

        dateString = dateString.toLocaleString('en-GB', { timeZone: 'UTC' })
        dateString = dateString.replace(',', '')

        return axios.uploadDocument('/Report/AppendReportDocument', state.reportItemWhole.requisition.requisitionId, dateString, null, data.data)
            .then((response) => {
                commit('requisitionDocumentAdd', {
                    id: response.data.reportDocumentId,
                    dateCreated: new Date().toISOString(),
                    name: data.file.name,
                    contentType: data.file.type,
                    icon: null,
                    dataSource: data.file.type.startsWith('image/') ? window.URL.createObjectURL(data.file) : null,
                    photoTaken: data.dataType.includes('image/') ? data.file.lastModifiedDate || new Date(data.file.lastModified) : null,
                    description: null,
                    origin: {
                        name: 'requisition',
                        id: state.reportItemWhole.requisition.requisitionId
                    },

                    raw: data
                })
            })
            .catch((error) => {
                return new Promise((resolve, reject) => {
                    reject(error)
                })
            })
    },
    requisitionDocumentRemove: ({commit, dispatch}, id) => {
        return axios.post('/Report/DeleteReportDocument', {
            RequisitionId: state.reportItemWhole.requisition.requisitionId,
            ReportDocumentId: id
        })
            .then((response) => {
                return new Promise((resolve, reject) => {
                    const file = state.requisitionDocuments.find(document => document.id === JSON.parse(response.config.data).ReportDocumentId)
                    const index = state.requisitionDocuments.indexOf(file)

                    if (file.dataSource) {
                        window.URL.revokeObjectURL(file.dataSource)
                    }
                    commit('detachRequisitionDocument', index)
                    resolve(response, id)
                })
            }, (error) => {
                return new Promise((resolve, reject) => {
                    reject(error)
                })
            })
    },
    requisitionDocumentOpen: ({commit, dispatch}, payload) => {
        let requestURL = null
        let requestData = {}

        if (payload.origin.name === 'enquiry' && payload.origin.id) {
            requestURL = '/Report/GetSharedRequestDocumentStream'
            requestData = {
                RequestId: payload.origin.id,
                RequestDocumentId: payload.id
            }
        } else if (payload.origin.name === 'task' && payload.origin.id) {
            requestURL = '/Report/GetTaskDocumentStream'
            requestData = {
                TaskId: payload.origin.id,
                TaskDocumentId: payload.id
            }
        } else if (payload.origin.name === 'requisition' && payload.origin.id) {
            requestURL = '/Report/GetReportDocumentStream'
            requestData = {
                RequisitionId: payload.origin.id,
                ReportDocumentId: payload.id
            }
        }

        return axios.downloadDocument(requestURL, requestData)
            .then(response => {
                return new Promise((resolve, reject) => {
                    let blob = new Blob([response.data], { type: payload.contentType })

                    if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                        window.navigator.msSaveOrOpenBlob(blob, payload.name)
                        resolve(blob)
                    }

                    const data = window.URL.createObjectURL(blob)
                    var link = document.createElement('a')
                    link.href = data
                    link.target = '_blank'
                    link.click()

                    resolve(blob)
                })
            })
    },
    requisitionDocumentDownload: ({commit, dispatch}, payload) => {
        let requestURL = null
        let requestData = {}

        if (payload.origin.name === 'enquiry' && payload.origin.id) {
            requestURL = '/Report/GetSharedRequestDocumentStream'
            requestData = {
                RequestId: payload.origin.id,
                RequestDocumentId: payload.id
            }
        } else if (payload.origin.name === 'task' && payload.origin.id) {
            requestURL = '/Report/GetTaskDocumentStream'
            requestData = {
                TaskId: payload.origin.id,
                TaskDocumentId: payload.id
            }
        } else if (payload.origin.name === 'requisition' && payload.origin.id) {
            requestURL = '/Report/GetReportDocumentStream'
            requestData = {
                RequisitionId: payload.origin.id,
                ReportDocumentId: payload.id
            }
        }

        return axios.downloadDocument(requestURL, requestData)
            .then(response => {
                return new Promise((resolve, reject) => {
                    let blob = new Blob([response.data], { type: payload.contentType })

                    if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                        window.navigator.msSaveOrOpenBlob(blob, payload.name)
                        resolve(blob)
                    }

                    const data = window.URL.createObjectURL(blob)
                    var link = document.createElement('a')
                    link.href = data
                    if (payload.photoTaken !== null) {
                        const documentName = payload.fileName ? payload.fileName : payload.name
                        const ext = documentName.split('.').pop()
                        const fileName = window['moment'].utc(payload.photoTaken).local().format('YYYYMMDD[_]HHmm')

                        if (fileName !== null & ext !== null) {
                            link.download = fileName.concat('.', ext)
                        } else {
                            link.download = documentName
                        }
                    } else {
                        link.download = payload.name
                    }
                    link.click()

                    resolve(blob)
                })
            })
    },
    requisitionDescriptionUpdate: ({ commit, dispatch }, file) => {
        axios.post('/Report/SetReportDocumentDescription', {
            requisitionId: state.reportItemWhole.requisition.requisitionId,
            reportDocumentId: file.id,
            reportDocumentVersionStamp: file.raw.reportDocumentVersionStamp,
            description: file.description
        })
            .then((response) => {
                file.raw.reportDocumentVersionStamp = response.data.reportDocumentVersionStamp
                commit('updateRequisitionDocuments', { data: [file] })
            })
            .catch((error) => {
                commit('errorHandler', error)
                throw error
            })
    },

    requisitionDocumentDescriptionUpdate ({dispatch, commit}, file) {
        axios.post('/Report/SetReportDocumentDescription', {
            requisitionId: file.origin.id,
            reportDocumentId: file.id,
            reportDocumentVersionStamp: file.raw.reportDocumentVersionStamp,
            description: file.description
        })
            .then((response) => {
                file.raw.reportDocumentVersionStamp = response.data.reportDocumentVersionStamp
                commit('updateTaskSelectedRequisitionsDocumentVersion', file)
            })
            .catch((error) => {
                commit('errorHandler', error)
                throw error
            })
    },
    createRequisition: ({ dispatch, commit }, payload) => {
        axios.post('/Requisition/CreateRequisitions', payload).then((response) => {
            commit('successHandler', response.status)
        }, (response) => {
            commit('errorHandler', response)
        })
    },
    getReportBbox ({ commit, dispatch }, payload) {
        return axios.post('/Report/GetWholeReportItem', {
            requisitionId: payload.id,
            bBox: payload.bBox
        })
            .then((response) => {
                state.reportItemWhole.objectList = response.data.objectList

                return state.reportItemWhole.objectList
            })
    },
    getReport: ({ commit, dispatch }, payload) => {
        return axios.post('/Report/GetWholeReportItem', {
            requisitionId: payload.id
        })
            .then((response) => {
                commit('addRequisitionVersionStamp', response.data.requisition.requisitionVersionStamp)
                commit('addWholeReportItem', response.data)
            })
            .then(() => {
                return axios.post('/Report/GetReportDocumentList', { requisitionId: payload.id })
                    .then((response) => {
                        commit('updateRequisitionDocuments', response)
                    })
                    .catch((response) => {
                        commit('errorHandler', response)
                    })
            })
            .then(() => {
                return axios.post('/Report/GetTaskDocumentList', { taskId: state.reportItemWhole.task.taskId })
                    .then((response) => {
                        commit('updateTaskDocuments', response)
                    })
                    .then(() => {
                        const promises = []

                        state.reportItemWhole.taskDocumentList.forEach((file) => {
                            const promise = new Promise((resolve) => {
                                resolve(file)
                            })

                            promises.push(promise)
                        })

                        return Promise.all(promises)
                            .then(() => {
                            })
                            .catch((error) => {
                                console.error(error)
                            })
                    })
                    .catch((response) => {
                        commit('errorHandler', response)
                    })
            })
            .catch((response) => {
                commit('errorHandler', response)
            })
    },
    setReportClear: ({ commit }) => {
        commit('setReportClear')
    },
    setReport: ({ commit, dispatch }, reportObject) => {
        return axios.post('/Report/SetReportObjects', reportObject).then((response) => {
            commit('addObjectActivityVersionStamp', response.data)
            commit('successHandler', response.status)
        }, (response) => {
            commit('errorHandler', response)
        })
    },
    setReportReadyForApproval: ({ commit, dispatch }, data) => {
        return axios.post('/Report/SetReportReadyForApproval', data).then((response) => {
            commit('successHandler', response.status)
            return response
        }, (response) => {
            commit('errorHandler', response)
        })
    },
    setReportObjectNote: ({ commit, dispatch }, data) => {
        return axios.post('/Report/SetReportObjectNote', data).then((response) => {
            commit('addObjectActivityVersionStamp', response.data.objectActivityVersionStamp)

            // update report note to object
            if (data.reportNote !== null && response.data.objectId && response.data.activityId) {
                if (state.reportItemWhole.objectList.length > 0) {
                    state.reportItemWhole.objectList.forEach(object => {
                        if (object.objectId === response.data.objectId) {
                            if (object.activityList.length > 0) {
                                object.activityList.forEach(activity => {
                                    if (activity) {
                                        if (activity.activityId === response.data.activityId) {
                                            activity.reportNote = data.reportNote
                                        }
                                    }
                                })
                            }
                        }
                    })
                }
            }
        }, (response) => {
            commit('errorHandler', response)
        })
    },
    setRequisitionStatus: ({ commit, dispatch, rootState }, data) => {
        if (data.length) {
            return new Promise((resolve, reject) => {
                data.forEach(req => {
                    axios.post('/Requisition/SetRequisitionStatus', req).then((response) => {
                        resolve(response)
                    }, (response) => {
                        reject(response)
                    })
                })
            }).then(() => {
                dispatch('getQueryRequisitionList', {whereOwnerUserIdList: rootState.global.userInfo.userId})
            })
        } else {
            return axios.post('/Requisition/SetRequisitionStatus', data).then((response) => {
                commit('addRequisitionVersionStamp', response.data.requisitionVersionStamp)
            }, (response) => {
                commit('errorHandler', response)
                return response
            })
        }
    },
    setObjectActivityVersionStamp: ({ commit }, versionStamp) => {
        commit('addObjectActivityVersionStamp', versionStamp)
    },
    setEntrepreneur: ({ commit, dispatch }, report) => {
        let activityIdList = []
        let activityVersionStampList = []
        for (let i in report.activities) {
            activityIdList[i] = report.activities[i].activityId
            activityVersionStampList[i] = report.activities[i].activityVersionStamp
        }
        let requisition = {
            requisitionId: report.requisition.requisitionId,
            activityIdList: activityIdList,
            activityVersionStampList: activityVersionStampList,
            sentToUserId: report.ownerUserId
        }
        return new Promise((resolve, reject) => {
            resolve(axios.post('/Report/SetActivitySentToUser', requisition))
        }).then((response) => {
            commit('successHandler', response.status)
            return response.data
        }, response => {
            commit('errorHandler', response)
            return response
        })
    },
    updateReportObjectList: ({ commit }, data) => {
        const params = {
            taskId: data.taskId
        }
        if (data.requisitionId) {
            params.requisitionId = data.requisitionId
        }
        if (data.wkt) {
            params.polygonWkt = data.wkt
        }
        if (data.objectIdList) {
            params.objectIdList = data.objectIdList
        }
        if (!data.requisition) {
            commit('updateReportObjectList', data.requisition)
        } else {
            axios.post('Report/GetObjectsAndActivitiesList', params)
                .then((response) => {
                    if (response.data.length > 0) {
                        commit('updateReportObjectList', response.data)
                    }
                })
                .catch((err) => {
                    commit('errorHandler', err)
                    throw err
                })
        }
    },
    clearReportObjectActivitiesFilter: ({ commit }) => {
        commit('clearReportObjectActivitiesFilter')
        commit('setReportFullObjectList', [])
    },
    setReportFullObjectList: ({ commit }, data) => {
        commit('setReportFullObjectList', data)
    }
}

export default {
    state,
    getters,
    mutations,
    actions
}



// WEBPACK FOOTER //
// ./src/store/requisition/requisition.js